import React, { useState, useEffect, useRef } from 'react';
import {
  FiSettings, FiMonitor, FiUsers, FiShield, FiActivity, FiFileText,
  FiEye, FiEyeOff, FiRefreshCw, FiSave, FiCheckCircle, FiAlertCircle,
  FiPlus, FiEdit2, FiUserX, FiUserCheck, FiX, FiLayers, FiClipboard, FiTrash2, FiRepeat,
  FiMail, FiZap, FiLink,
} from 'react-icons/fi';
import FichaCadastralTabs, { FICHA_VAZIA } from '../clientes/fichaCadastral/components/FichaCadastralTabs';
import Auditoria from '../auditoria';
import DocsTab from './DocsTab';
import {
  buscarConfigSistema,
  salvarConfigSistema,
  buscarModelosClaude,
} from '../../services/configuracoes';
import {
  listarUsuarios,
  criarUsuario,
  atualizarUsuario,
  toggleAtivoUsuario,
  redefinirSenhaUsuario,
  sucederUsuario,
} from '../../services/usuarios';
import {
  MENUS_SISTEMA,
  buscarPermissoesUsuario,
  salvarPermissoesUsuario,
} from '../../services/permissoes';
import { listarDepartamentosNiboAPI } from '../../services/rotinas';
import { listarUsuariosNiboAPI, atualizarStatusUsuarioNibo } from '../../services/rotinas';
import { usuarioLogado, atualizarMeuPerfil, alterarMinhaSenha } from '../../services/auth';
import {
  listarContasEmail, criarContaEmail, atualizarContaEmail, excluirContaEmail, testarContaEmail,
} from '../../services/emailContas';
import styles from './Configuracoes.module.css';

/* ===== Abas ===== */

const ABAS = [
  { id: 'sistema',         label: 'Sistema',          icon: FiMonitor  },
  { id: 'usuarios',        label: 'Usuários',         icon: FiUsers    },
  { id: 'perfil-acesso',   label: 'Perfil de Acesso', icon: FiShield   },
  { id: 'contratos',       label: 'Contratos',        icon: FiFileText },
  { id: 'modelos-ficha',   label: 'Modelos de Ficha', icon: FiLayers   },
  { id: 'nibo-responsaveis', label: 'Responsáveis (Nibo)', icon: FiUserCheck },
  { id: 'email',           label: 'E-mail',           icon: FiMail    },
  { id: 'docs',            label: 'Docs',             icon: FiLink    },
  { id: 'auditoria',       label: 'Auditoria',        icon: FiActivity },
];

/* ===== Placeholder ===== */

function Placeholder({ titulo }) {
  return (
    <div className={styles.placeholder}>
      <p className={styles.placeholderTitulo}>{titulo}</p>
      <p className={styles.placeholderSub}>Em construção — em breve disponível.</p>
    </div>
  );
}

/* ===== Aba Sistema ===== */

function SistemaTab() {
  const [configurada,   setConfigurada]   = useState(false);
  const [chave,         setChave]         = useState('');
  const [mostrarChave,  setMostrarChave]  = useState(false);
  const [modelo,        setModelo]        = useState('');
  const [modelos,       setModelos]       = useState([]);
  const [carregando,    setCarregando]    = useState(true);
  const [carregandoMod, setCarregandoMod] = useState(false);
  const [salvando,      setSalvando]      = useState(false);
  const [erro,          setErro]          = useState('');
  const [sucesso,       setSucesso]       = useState('');

  useEffect(() => {
    buscarConfigSistema()
      .then(cfg => {
        setConfigurada(cfg.configurada);
        setModelo(cfg.claude_modelo || '');
      })
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, []);

  async function handleCarregarModelos() {
    setCarregandoMod(true);
    setErro('');
    try {
      const lista = await buscarModelosClaude();
      setModelos(lista);
      if (lista.length > 0 && !modelo) setModelo(lista[0].id);
    } catch (e) {
      setErro(e.message);
    } finally {
      setCarregandoMod(false);
    }
  }

  async function handleSalvar() {
    setSalvando(true);
    setErro('');
    setSucesso('');
    try {
      await salvarConfigSistema({
        ...(chave ? { claude_api_key: chave } : {}),
        claude_modelo: modelo,
      });
      setConfigurada(true);
      setChave('');
      setSucesso('Configurações salvas com sucesso.');
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  }

  if (carregando) {
    return <p className={styles.placeholderSub}>Carregando configurações...</p>;
  }

  return (
    <div className={styles.sistemaWrap}>

      {/* Card de integração */}
      <div className={styles.integracaoCard}>
        <div className={styles.integracaoCardHeader}>
          <div className={styles.integracaoCardTitulo}>
            <span className={styles.integracaoCardIcone}>✦</span>
            Integração Claude AI
          </div>
          <span className={`${styles.statusBadge} ${configurada ? styles.statusConectado : styles.statusNaoConf}`}>
            {configurada
              ? <><FiCheckCircle size={12} /> Conectado</>
              : <><FiAlertCircle size={12} /> Não configurado</>}
          </span>
        </div>

        <p className={styles.integracaoDesc}>
          Configure a chave de API do Claude (Anthropic) para habilitar recursos de inteligência artificial no ERP.
        </p>

        {/* Chave de API */}
        <div className={styles.campo}>
          <label className={styles.label}>
            Chave de API (API Key)
          </label>
          <div className={styles.chaveWrap}>
            <input
              type={mostrarChave ? 'text' : 'password'}
              className={styles.input}
              value={chave}
              onChange={e => setChave(e.target.value)}
              placeholder={configurada ? '••••••••••••  (já configurada — deixe em branco para manter)' : 'sk-ant-api03-...'}
              autoComplete="off"
            />
            <button
              type="button"
              className={styles.btnOlho}
              onClick={() => setMostrarChave(v => !v)}
              title={mostrarChave ? 'Ocultar' : 'Mostrar'}
            >
              {mostrarChave ? <FiEyeOff size={15} /> : <FiEye size={15} />}
            </button>
          </div>
          {configurada && (
            <p className={styles.campoHint}>
              Uma chave já está salva. Preencha apenas para substituí-la.
            </p>
          )}
        </div>

        {/* Modelo */}
        <div className={styles.campo}>
          <div className={styles.modeloHeader}>
            <label className={styles.label}>Modelo</label>
            <button
              type="button"
              className={styles.btnCarregarModelos}
              onClick={handleCarregarModelos}
              disabled={carregandoMod}
            >
              <FiRefreshCw size={13} className={carregandoMod ? styles.girando : ''} />
              {carregandoMod ? 'Carregando...' : 'Carregar modelos via API'}
            </button>
          </div>

          {modelos.length > 0 ? (
            <select
              className={styles.select}
              value={modelo}
              onChange={e => setModelo(e.target.value)}
            >
              {modelos.map(m => (
                <option key={m.id} value={m.id}>{m.nome}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              className={styles.input}
              value={modelo}
              onChange={e => setModelo(e.target.value)}
              placeholder="Ex: claude-sonnet-4-6 — ou clique em Carregar modelos"
            />
          )}
          <p className={styles.campoHint}>
            Salve a chave e clique em "Carregar modelos" para listar os modelos disponíveis na sua conta.
          </p>
        </div>

        {/* Feedback */}
        {erro    && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>}
        {sucesso && <div className={styles.sucessoFaixa}><FiCheckCircle size={14} /> {sucesso}</div>}

        {/* Ação */}
        <div className={styles.integracaoFooter}>
          <button
            type="button"
            className={styles.btnSalvar}
            onClick={handleSalvar}
            disabled={salvando}
          >
            <FiSave size={14} />
            {salvando ? 'Salvando...' : 'Salvar Configurações'}
          </button>
        </div>
      </div>

    </div>
  );
}

/* ===== Aba Usuários ===== */

const TIPOS = ['admin', 'gerente', 'usuario'];
const TIPO_LABEL = { admin: 'Admin', gerente: 'Gerente', usuario: 'Usuário' };
const TIPO_COR   = { admin: 'tipAdmin', gerente: 'tipGerente', usuario: 'tipUsuario' };

const FORM_VAZIO = { nome: '', email: '', senha: '', tipo: 'usuario', setor: '' };

function UsuariosTab() {
  const [, forcarRender]                = useState(0); // força reler o eu (localStorage) depois de editar o próprio perfil
  const eu                              = usuarioLogado();
  const [usuarios,      setUsuarios]    = useState([]);
  const [carregando,    setCarregando]  = useState(true);
  const [mostrarOcultos,setMostrarOcultos] = useState(false);
  const [sucedendo, setSucedendo] = useState(null); // usuário sendo substituído
  const [formAberto,    setFormAberto]  = useState(false);
  const [editando,      setEditando]    = useState(null); // objeto usuario
  const [form,          setForm]        = useState(FORM_VAZIO);
  const [mostrarSenha,  setMostrarSenha] = useState(false);
  const [salvando,      setSalvando]    = useState(false);
  const [erro,          setErro]        = useState('');
  const [departamentos, setDepartamentos] = useState([]);
  const [senhaAtual,    setSenhaAtual]  = useState('');
  const [novaSenha,     setNovaSenha]   = useState('');
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [erroSenha,     setErroSenha]   = useState('');
  const [sucessoSenha,  setSucessoSenha] = useState(false);

  /* setores vêm dos departamentos da Nibo -- mesma lista usada pra vincular
     um setor a um Grupo de fluxo, garante que o texto bata igual dos dois
     lados na hora de comparar setor do usuário x setor do grupo */
  useEffect(() => {
    listarDepartamentosNiboAPI().then(r => setDepartamentos(r.items || [])).catch(() => {});
  }, []);

  /* Linha "eu" como admin fixo */
  const euLinha = {
    id: '__eu__',
    nome: eu?.nome || eu?.email || 'Você',
    email: eu?.email || '',
    setor: eu?.setor || '',
    tipo: 'admin',
    ativo: true,
    criado_em: null,
    __eu: true,
  };

  useEffect(() => {
    listarUsuarios()
      .then(setUsuarios)
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, []);

  function abrirNovo() {
    setEditando(null);
    setForm(FORM_VAZIO);
    setMostrarSenha(false);
    setErro('');
    setFormAberto(true);
  }

  function abrirEdicao(u) {
    setEditando(u);
    setForm({ nome: u.nome || '', email: u.email, senha: '', tipo: u.tipo, setor: u.setor || '' });
    setMostrarSenha(false);
    setErro('');
    setSenhaAtual(''); setNovaSenha(''); setErroSenha(''); setSucessoSenha(false);
    setFormAberto(true);
  }

  function fecharForm() {
    setFormAberto(false);
    setEditando(null);
    setErro('');
  }

  async function handleTrocarSenha() {
    setErroSenha(''); setSucessoSenha(false);
    if (novaSenha.length < 8) return setErroSenha('Nova senha mínima de 8 caracteres');
    setSalvandoSenha(true);
    try {
      if (editando.__eu) {
        if (!senhaAtual) { setErroSenha('Informe a senha atual'); return; }
        await alterarMinhaSenha({ senhaAtual, novaSenha });
      } else {
        await redefinirSenhaUsuario(editando.id, novaSenha);
      }
      setSenhaAtual(''); setNovaSenha(''); setSucessoSenha(true);
    } catch (e) {
      setErroSenha(e.message);
    } finally {
      setSalvandoSenha(false);
    }
  }

  async function handleSalvar() {
    setErro('');
    if (!editando && !form.email.trim()) return setErro('E-mail obrigatório');
    if (!editando && form.senha.length < 8) return setErro('Senha mínima de 8 caracteres');

    setSalvando(true);
    try {
      if (editando?.__eu) {
        await atualizarMeuPerfil({ nome: form.nome, setor: form.setor });
        forcarRender(v => v + 1);
      } else if (editando) {
        const atualizado = await atualizarUsuario(editando.id, { nome: form.nome, tipo: form.tipo, setor: form.setor });
        setUsuarios(prev => prev.map(u => u.id === editando.id ? atualizado : u));
      } else {
        const novo = await criarUsuario({ email: form.email, senha: form.senha, nome: form.nome, tipo: form.tipo, setor: form.setor });
        setUsuarios(prev => [...prev, novo]);
      }
      fecharForm();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function handleToggleAtivo(u) {
    try {
      const atualizado = await toggleAtivoUsuario(u.id, !u.ativo);
      setUsuarios(prev => prev.map(x => x.id === u.id ? atualizado : x));
    } catch (e) {
      setErro(e.message);
    }
  }

  /* troca de pessoa no setor: o e-mail é do escritório, quem muda é a
     pessoa. A anterior fica inativa na lista, com a história dela intacta. */
  function handleSucedido({ anterior, novo }) {
    setUsuarios(prev => [
      ...prev.map(x => (x.id === anterior.id ? { ...x, ativo: false } : x)),
      novo,
    ]);
    setSucedendo(null);
  }

  const visiveis = [euLinha, ...usuarios.filter(u => mostrarOcultos || u.ativo)];
  const qtdOcultos = usuarios.filter(u => !u.ativo).length;

  return (
    <div className={styles.usuariosWrap}>

      {/* Barra de ações */}
      <div className={styles.usuariosBarra}>
        <p className={styles.usuariosTotal}>
          {usuarios.length + 1} usuário{usuarios.length + 1 !== 1 ? 's' : ''} no sistema
        </p>
        <div className={styles.usuariosBarraAcoes}>
          {qtdOcultos > 0 && (
            <button
              type="button"
              className={`${styles.btnOcultos} ${mostrarOcultos ? styles.btnOcultosAtivo : ''}`}
              onClick={() => setMostrarOcultos(v => !v)}
            >
              <FiEye size={13} />
              {mostrarOcultos ? `Ocultar inativos (${qtdOcultos})` : `Mostrar inativos (${qtdOcultos})`}
            </button>
          )}
          <button type="button" className={styles.btnNovoUsuario} onClick={abrirNovo}>
            <FiPlus size={14} /> Novo Usuário
          </button>
        </div>
      </div>

      {erro && !formAberto && (
        <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>
      )}

      {sucedendo && (
        <FormSucessao
          usuario={sucedendo}
          onFechar={() => setSucedendo(null)}
          onSucedido={handleSucedido}
        />
      )}

      {/* Formulário inline */}
      {formAberto && (
        <div className={styles.usuarioForm}>
          <div className={styles.usuarioFormHeader}>
            <span className={styles.usuarioFormTitulo}>
              {editando ? 'Editar Usuário' : 'Novo Usuário'}
            </span>
            <button type="button" className={styles.btnFecharForm} onClick={fecharForm}>
              <FiX size={15} />
            </button>
          </div>

          <div className={styles.usuarioFormGrid}>
            <div className={styles.campo}>
              <label className={styles.label}>Nome</label>
              <input className={styles.input} value={form.nome}
                onChange={e => setForm(p => ({ ...p, nome: e.target.value }))}
                placeholder="Nome do usuário" />
            </div>

            <div className={styles.campo}>
              <label className={styles.label}>E-mail *</label>
              <input className={styles.input} type="email" value={form.email}
                onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
                placeholder="email@empresa.com.br"
                disabled={!!editando} />
            </div>

            {!editando && (
              <div className={styles.campo}>
                <label className={styles.label}>Senha * (mínimo 8 caracteres)</label>
                <div className={styles.chaveWrap}>
                  <input
                    className={styles.input}
                    type={mostrarSenha ? 'text' : 'password'}
                    value={form.senha}
                    onChange={e => setForm(p => ({ ...p, senha: e.target.value }))}
                    placeholder="••••••••"
                    autoComplete="new-password"
                  />
                  <button type="button" className={styles.btnOlho}
                    onClick={() => setMostrarSenha(v => !v)}>
                    {mostrarSenha ? <FiEyeOff size={15} /> : <FiEye size={15} />}
                  </button>
                </div>
              </div>
            )}

            <div className={styles.campo}>
              <label className={styles.label}>Setor</label>
              <select className={styles.input} value={form.setor}
                onChange={e => setForm(p => ({ ...p, setor: e.target.value }))}>
                <option value="">Sem setor definido</option>
                {departamentos.map(d => <option key={d.id} value={d.name}>{d.name}</option>)}
              </select>
            </div>

            {!editando?.__eu && (
              <div className={styles.campo}>
                <label className={styles.label}>Perfil *</label>
                <select className={styles.select} value={form.tipo}
                  onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))}>
                  {TIPOS.map(t => <option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                </select>
              </div>
            )}
          </div>

          {editando && (
            <div className={styles.usuarioFormGrid} style={{ marginTop: 4, paddingTop: 14, borderTop: '1px solid #eef2f7' }}>
              {editando.__eu && (
                <div className={styles.campo}>
                  <label className={styles.label}>Senha atual</label>
                  <input className={styles.input} type="password" value={senhaAtual}
                    onChange={e => setSenhaAtual(e.target.value)}
                    placeholder="••••••••" autoComplete="current-password" />
                </div>
              )}
              <div className={styles.campo}>
                <label className={styles.label}>
                  {editando.__eu ? 'Nova senha' : 'Redefinir senha (opcional)'}
                </label>
                <input className={styles.input} type="password" value={novaSenha}
                  onChange={e => setNovaSenha(e.target.value)}
                  placeholder="Mínimo 8 caracteres" autoComplete="new-password" />
              </div>
              <div className={styles.campo} style={{ alignSelf: 'end' }}>
                <button type="button" className={styles.btnCancelarForm} onClick={handleTrocarSenha} disabled={salvandoSenha || !novaSenha}>
                  {salvandoSenha ? 'Salvando...' : editando.__eu ? 'Trocar minha senha' : 'Redefinir senha'}
                </button>
              </div>
              {erroSenha && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erroSenha}</div>}
              {sucessoSenha && <div className={styles.sucessoFaixa}><FiCheckCircle size={14} /> Senha atualizada.</div>}
            </div>
          )}

          {erro && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>}

          <div className={styles.usuarioFormFooter}>
            <button type="button" className={styles.btnCancelarForm} onClick={fecharForm}>
              Cancelar
            </button>
            <button type="button" className={styles.btnSalvar} onClick={handleSalvar} disabled={salvando}>
              <FiSave size={14} /> {salvando ? 'Salvando...' : editando ? 'Salvar Alterações' : 'Criar Usuário'}
            </button>
          </div>
        </div>
      )}

      {/* Lista */}
      {carregando ? (
        <p className={styles.placeholderSub}>Carregando usuários...</p>
      ) : (
        <div className={styles.usuariosLista}>
          {visiveis.map(u => (
            <div
              key={u.id}
              className={`${styles.usuarioCard} ${!u.ativo ? styles.usuarioCardInativo : ''}`}
            >
              <div className={styles.usuarioAvatar}>
                {(u.nome || u.email || '?').charAt(0).toUpperCase()}
              </div>

              <div className={styles.usuarioInfo}>
                <div className={styles.usuarioNomeRow}>
                  <span className={styles.usuarioNome}>{u.nome || u.email}</span>
                  <span className={`${styles.tipoBadge} ${styles[TIPO_COR[u.tipo]]}`}>
                    {TIPO_LABEL[u.tipo]}
                  </span>
                  {!u.ativo && <span className={styles.inativoBadge}>Inativo</span>}
                  {u.__eu && <span className={styles.euBadge}>Você</span>}
                </div>
                <span className={styles.usuarioEmail}>{u.setor ? `${u.setor} — ${u.email}` : u.email}</span>
              </div>

              <div className={styles.usuarioAcoes}>
                <button type="button" className={styles.btnAcaoUsuario}
                  onClick={() => abrirEdicao(u)} title="Editar">
                  <FiEdit2 size={14} />
                </button>
                {!u.__eu && u.ativo && (
                  <button type="button" className={styles.btnAcaoUsuario}
                    onClick={() => setSucedendo(u)}
                    title="Substituir pessoa (mantém o e-mail do setor)">
                    <FiRepeat size={14} />
                  </button>
                )}
                {!u.__eu && (
                  <button
                    type="button"
                    className={`${styles.btnAcaoUsuario} ${u.ativo ? styles.btnInativar : styles.btnReativar}`}
                    onClick={() => handleToggleAtivo(u)}
                    title={u.ativo ? 'Inativar' : 'Reativar'}
                  >
                    {u.ativo ? <FiUserX size={14} /> : <FiUserCheck size={14} />}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}

/* ===== Substituir a pessoa do setor =====
   O e-mail pertence ao escritório (fiscal@..., folha@...) e a pessoa é
   que muda. Renomear o usuário apagaria a história: os registros da
   Andrea passariam a dizer "Alefe". Aqui a anterior é inativada e a nova
   nasce no mesmo e-mail, numa operação só. */
function FormSucessao({ usuario, onFechar, onSucedido }) {
  const [nome, setNome] = useState('');
  const [senha, setSenha] = useState('');
  const [manterSetor, setManterSetor] = useState(true);
  const [setor, setSetor] = useState(usuario.setor || '');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  async function confirmar() {
    if (!nome.trim()) { setErro('Informe o nome de quem entra.'); return; }
    if (senha.length < 8) { setErro('A senha precisa ter ao menos 8 caracteres.'); return; }
    setSalvando(true); setErro('');
    try {
      const r = await sucederUsuario(usuario.id, {
        nome: nome.trim(),
        senha,
        setor: manterSetor ? undefined : setor,
      });
      onSucedido(r);
    } catch (e) {
      setErro(e.message);
      setSalvando(false);
    }
  }

  return (
    <div className={styles.usuarioForm}>
      <div className={styles.usuarioFormHeader}>
        <span className={styles.usuarioFormTitulo}>Substituir pessoa do setor</span>
        <button type="button" className={styles.btnFecharForm} onClick={onFechar}>
          <FiX size={15} />
        </button>
      </div>

      <p className={styles.campoHint} style={{ marginBottom: 12 }}>
        <strong>{usuario.nome || usuario.email}</strong> sai e quem entra fica com o mesmo e-mail
        (<strong>{usuario.email}</strong>), porque o e-mail é do setor, não da pessoa. O acesso de quem
        sai é encerrado na hora, e tudo que ela registrou continua no nome dela.
      </p>

      <div className={styles.usuarioFormGrid}>
        <div className={styles.campo}>
          <label className={styles.label}>Nome de quem entra *</label>
          <input className={styles.input} value={nome} autoFocus
            onChange={e => setNome(e.target.value)} placeholder="Nome completo" />
        </div>

        <div className={styles.campo}>
          <label className={styles.label}>Senha de acesso *</label>
          <input className={styles.input} type="password" value={senha} autoComplete="new-password"
            onChange={e => setSenha(e.target.value)} placeholder="Mínimo 8 caracteres" />
        </div>

        <div className={styles.campo}>
          <label className={styles.label}>Setor</label>
          <label className={styles.campoHint} style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 6 }}>
            <input type="checkbox" checked={manterSetor} onChange={e => setManterSetor(e.target.checked)} />
            Manter em {usuario.setor || "(sem setor definido)"}
          </label>
          {!manterSetor && (
            <input className={styles.input} value={setor}
              onChange={e => setSetor(e.target.value)} placeholder="Novo setor" />
          )}
        </div>
      </div>

      {erro && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>}

      <div className={styles.usuarioFormFooter}>
        <button type="button" className={styles.btnCancelarForm} onClick={onFechar} disabled={salvando}>
          Cancelar
        </button>
        <button type="button" className={styles.btnSalvar} onClick={confirmar} disabled={salvando}>
          {salvando ? 'Substituindo...' : 'Substituir pessoa'}
        </button>
      </div>
    </div>
  );
}

/* ===== Aba Responsáveis (Nibo) =====
   A Nibo não marca quem saiu da empresa -- o /users dela lista todo mundo
   que já existiu, pra sempre. Guardamos aqui quem deve ficar oculto dos
   seletores de Responsável (calendário, tarefas etc.) do sistema. */
function NiboResponsaveisTab() {
  const [usuarios, setUsuarios]         = useState([]);
  const [carregando, setCarregando]     = useState(true);
  const [mostrarInativos, setMostrarInativos] = useState(false);
  const [erro, setErro]                 = useState('');

  useEffect(() => {
    listarUsuariosNiboAPI()
      .then(r => setUsuarios(r.items || []))
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, []);

  async function handleToggleAtivo(u) {
    try {
      await atualizarStatusUsuarioNibo(u.id, !u.ativo);
      setUsuarios(prev => prev.map(x => x.id === u.id ? { ...x, ativo: !u.ativo } : x));
    } catch (e) {
      setErro(e.message);
    }
  }

  const visiveis = usuarios.filter(u => mostrarInativos || u.ativo);
  const qtdInativos = usuarios.filter(u => !u.ativo).length;

  return (
    <div className={styles.usuariosWrap}>
      <div className={styles.usuariosBarra}>
        <p className={styles.usuariosTotal}>{visiveis.length} usuário{visiveis.length !== 1 ? 's' : ''}</p>
        <div className={styles.usuariosBarraAcoes}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={mostrarInativos} onChange={e => setMostrarInativos(e.target.checked)} />
            Mostrar inativos ({qtdInativos})
          </label>
        </div>
      </div>

      {erro && <p className={styles.placeholderSub}>{erro}</p>}

      {carregando ? (
        <p className={styles.placeholderSub}>Carregando...</p>
      ) : (
        <div className={styles.usuariosLista}>
          {visiveis.map(u => (
            <div key={u.id} className={`${styles.usuarioCard} ${!u.ativo ? styles.usuarioCardInativo : ''}`}>
              <div className={styles.usuarioAvatar}>{(u.name || u.email || '?').charAt(0).toUpperCase()}</div>
              <div className={styles.usuarioInfo}>
                <div className={styles.usuarioNomeRow}>
                  <span className={styles.usuarioNome}>{u.name}</span>
                  {!u.ativo && <span className={styles.inativoBadge}>Inativo</span>}
                </div>
                <span className={styles.usuarioEmail}>{u.email}</span>
              </div>
              <div className={styles.usuarioAcoes}>
                <button
                  type="button"
                  className={`${styles.btnAcaoUsuario} ${u.ativo ? styles.btnInativar : styles.btnReativar}`}
                  onClick={() => handleToggleAtivo(u)}
                  title={u.ativo ? 'Marcar como inativo' : 'Marcar como ativo'}
                >
                  {u.ativo ? <FiUserX size={14} /> : <FiUserCheck size={14} />}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <p className={styles.placeholderSub} style={{ marginTop: 16 }}>
        Essa lista vem da Nibo, mas ela não sinaliza quem saiu da empresa. Marque como inativo quem não trabalha
        mais aqui -- some dos seletores de Responsável em Obrigações, Tarefas etc.
      </p>
    </div>
  );
}

/* ===== Aba Perfil de Acesso ===== */

const GRUPOS = [...new Set(MENUS_SISTEMA.map(m => m.grupo).filter(Boolean))];

function PerfilAcessoTab() {
  const [usuarios,      setUsuarios]      = useState([]);
  const [carregando,    setCarregando]    = useState(true);
  const [usuarioSel,    setUsuarioSel]    = useState(null);
  const [menus,         setMenus]         = useState([]);
  const [carregPerm,    setCarregPerm]    = useState(false);
  const [salvando,      setSalvando]      = useState(false);
  const [sucesso,       setSucesso]       = useState('');
  const [erro,          setErro]          = useState('');

  useEffect(() => {
    listarUsuarios()
      .then(u => setUsuarios(u.filter(x => x.ativo)))
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, []);

  async function handleSelecionarUsuario(u) {
    setUsuarioSel(u);
    setSucesso('');
    setErro('');
    setCarregPerm(true);
    try {
      const { menus: m } = await buscarPermissoesUsuario(u.id);
      setMenus(m || []);
    } catch (e) {
      setErro(e.message);
    } finally {
      setCarregPerm(false);
    }
  }

  function toggleMenu(key) {
    setMenus(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  }

  function toggleGrupo(grupo) {
    const keys = MENUS_SISTEMA.filter(m => m.grupo === grupo).map(m => m.key);
    const todosAtivos = keys.every(k => menus.includes(k));
    if (todosAtivos) {
      setMenus(prev => prev.filter(k => !keys.includes(k)));
    } else {
      setMenus(prev => [...new Set([...prev, ...keys])]);
    }
  }

  function toggleParent(parentKey) {
    const keys = MENUS_SISTEMA.filter(m => m.parent === parentKey).map(m => m.key);
    const todosAtivos = keys.every(k => menus.includes(k));
    if (todosAtivos) {
      setMenus(prev => prev.filter(k => !keys.includes(k)));
    } else {
      setMenus(prev => [...new Set([...prev, ...keys])]);
    }
  }

  async function handleSalvar() {
    if (!usuarioSel) return;
    setSalvando(true);
    setSucesso('');
    setErro('');
    try {
      /* Itens com filhos (ex: "clientes/clientes") só têm
         checkbox pros filhos na UI — nunca dá pra marcar a chave do pai
         diretamente. Sem isso, o pai nunca entra em "menus" e o item some
         do menu principal do usuário (a Estrutura.jsx exige a chave do pai
         pra mostrar o item), mesmo com filhos marcados. */
      const pais = new Set(MENUS_SISTEMA.filter(m => m.parent).map(m => m.parent));
      const paisAtivos = MENUS_SISTEMA
        .filter(m => m.parent && menus.includes(m.key))
        .map(m => m.parent);
      const menusParaSalvar = [...new Set([...menus.filter(k => !pais.has(k)), ...paisAtivos])];

      await salvarPermissoesUsuario(usuarioSel.id, menusParaSalvar);
      setMenus(menusParaSalvar);
      setSucesso('Permissões salvas com sucesso.');
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  }

  const menusSemGrupo = MENUS_SISTEMA.filter(m => !m.grupo && !m.parent);

  return (
    <div className={styles.perfilWrap}>

      {/* Coluna esquerda — lista de usuários */}
      <div className={styles.perfilUsuarios}>
        <p className={styles.perfilSecaoTitulo}>Usuários ativos</p>
        {carregando ? (
          <p className={styles.placeholderSub}>Carregando...</p>
        ) : usuarios.length === 0 ? (
          <p className={styles.placeholderSub}>Nenhum sub-usuário cadastrado.</p>
        ) : (
          usuarios.map(u => (
            <button
              key={u.id}
              type="button"
              className={`${styles.perfilUsuarioBtn} ${usuarioSel?.id === u.id ? styles.perfilUsuarioBtnAtivo : ''}`}
              onClick={() => handleSelecionarUsuario(u)}
            >
              <div className={styles.perfilAvatar}>
                {(u.nome || u.email).charAt(0).toUpperCase()}
              </div>
              <div className={styles.perfilUsuarioInfo}>
                <span className={styles.perfilUsuarioNome}>{u.nome || u.email}</span>
                <span className={styles.perfilUsuarioEmail}>{u.email}</span>
              </div>
              <span className={`${styles.tipoBadge} ${styles[TIPO_COR[u.tipo]]}`}>
                {TIPO_LABEL[u.tipo]}
              </span>
            </button>
          ))
        )}
      </div>

      {/* Coluna direita — permissões */}
      <div className={styles.perfilPermissoes}>
        {!usuarioSel ? (
          <div className={styles.perfilVazio}>
            <p className={styles.perfilVazioTitulo}>Selecione um usuário</p>
            <p className={styles.placeholderSub}>Clique em um usuário à esquerda para gerenciar seus acessos.</p>
          </div>
        ) : carregPerm ? (
          <p className={styles.placeholderSub}>Carregando permissões...</p>
        ) : (
          <>
            <div className={styles.perfilPermHeader}>
              <div>
                <p className={styles.perfilSecaoTitulo}>
                  Acessos de <strong>{usuarioSel.nome || usuarioSel.email}</strong>
                </p>
                <p className={styles.placeholderSub}>
                  Módulos marcados ficam visíveis e acessíveis para este usuário.
                </p>
              </div>
            </div>

            {erro && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>}
            {sucesso && <div className={styles.sucessoFaixa}><FiCheckCircle size={14} /> {sucesso}</div>}

            <div className={styles.perfilMenusLista}>
              {/* Menus sem grupo */}
              {menusSemGrupo.map(m => {
                const filhos = MENUS_SISTEMA.filter(f => f.parent === m.key);
                if (filhos.length > 0) {
                  const todosFilhosAtivos = filhos.every(f => menus.includes(f.key));
                  const algumFilhoAtivo   = filhos.some(f => menus.includes(f.key));
                  return (
                    <div key={m.key} className={styles.perfilSubGrupo}>
                      <button
                        type="button"
                        className={styles.perfilSubGrupoHeader}
                        onClick={() => toggleParent(m.key)}
                      >
                        <span className={`${styles.perfilGrupoCheck} ${todosFilhosAtivos ? styles.perfilGrupoCheckAtivo : algumFilhoAtivo ? styles.perfilGrupoCheckParcial : ''}`} />
                        <span className={styles.perfilSubGrupoNome}>{m.label}</span>
                        {m.hint && <span className={styles.perfilSubGrupoHint}>{m.hint}</span>}
                      </button>
                      <div className={styles.perfilSubGrupoItens}>
                        {filhos.map(f => (
                          <label key={f.key} className={styles.perfilMenuItemSubSub}>
                            <input
                              type="checkbox"
                              className={styles.perfilCheckbox}
                              checked={menus.includes(f.key)}
                              onChange={() => toggleMenu(f.key)}
                            />
                            <span className={styles.perfilMenuLabel}>{f.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  );
                }
                return (
                  <label key={m.key} className={styles.perfilMenuItem}>
                    <input
                      type="checkbox"
                      className={styles.perfilCheckbox}
                      checked={menus.includes(m.key)}
                      onChange={() => toggleMenu(m.key)}
                    />
                    <span className={styles.perfilMenuLabel}>{m.label}</span>
                  </label>
                );
              })}

              {/* Grupos com submenus */}
              {GRUPOS.map(grupo => {
                const todosItens  = MENUS_SISTEMA.filter(m => m.grupo === grupo);
                const todosAtivos = todosItens.every(m => menus.includes(m.key));
                const algumAtivo  = todosItens.some(m => menus.includes(m.key));
                // top-level items inside the group (not children of another item)
                const itensDiretos = todosItens.filter(m => !m.parent);
                return (
                  <div key={grupo} className={styles.perfilGrupo}>
                    <button
                      type="button"
                      className={styles.perfilGrupoHeader}
                      onClick={() => toggleGrupo(grupo)}
                    >
                      <span className={`${styles.perfilGrupoCheck} ${todosAtivos ? styles.perfilGrupoCheckAtivo : algumAtivo ? styles.perfilGrupoCheckParcial : ''}`} />
                      <span className={styles.perfilGrupoNome}>{grupo}</span>
                    </button>
                    <div className={styles.perfilGrupoItens}>
                      {itensDiretos.map(m => {
                        const filhos = MENUS_SISTEMA.filter(f => f.parent === m.key);
                        if (filhos.length > 0) {
                          const todosFilhosAtivos = filhos.every(f => menus.includes(f.key));
                          const algumFilhoAtivo   = filhos.some(f => menus.includes(f.key));
                          return (
                            <div key={m.key} className={styles.perfilSubGrupo}>
                              <button
                                type="button"
                                className={styles.perfilSubGrupoHeader}
                                onClick={() => toggleParent(m.key)}
                              >
                                <span className={`${styles.perfilGrupoCheck} ${todosFilhosAtivos ? styles.perfilGrupoCheckAtivo : algumFilhoAtivo ? styles.perfilGrupoCheckParcial : ''}`} />
                                <span className={styles.perfilSubGrupoNome}>{m.label}</span>
                                {m.hint && <span className={styles.perfilSubGrupoHint}>{m.hint}</span>}
                              </button>
                              <div className={styles.perfilSubGrupoItens}>
                                {filhos.map(f => (
                                  <label key={f.key} className={styles.perfilMenuItemSubSub}>
                                    <input
                                      type="checkbox"
                                      className={styles.perfilCheckbox}
                                      checked={menus.includes(f.key)}
                                      onChange={() => toggleMenu(f.key)}
                                    />
                                    <span className={styles.perfilMenuLabel}>{f.label}</span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          );
                        }
                        return (
                          <label key={m.key} className={styles.perfilMenuItemSub}>
                            <input
                              type="checkbox"
                              className={styles.perfilCheckbox}
                              checked={menus.includes(m.key)}
                              onChange={() => toggleMenu(m.key)}
                            />
                            <span className={styles.perfilMenuLabel}>{m.label}</span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={styles.perfilPermFooter}>
              <button
                type="button"
                className={styles.btnSalvar}
                onClick={handleSalvar}
                disabled={salvando}
              >
                <FiSave size={14} />
                {salvando ? 'Salvando...' : 'Salvar Permissões'}
              </button>
            </div>
          </>
        )}
      </div>

    </div>
  );
}

/* ===== Aba Modelos de Ficha (espelho da Ficha Cadastral — modelos base) ===== */

function ModelosFichaTab() {
  const [modelos, setModelos]         = useState([
    { id: 1, nome: 'Simples Nacional — Padrão', dados: FICHA_VAZIA, vinculos: 0 },
  ]);
  const [selecionado, setSelecionado] = useState(null);
  const proximoId = useRef(2);

  function criarModelo() {
    const nome = window.prompt('Nome do modelo (ex: Lucro Presumido — Padrão)');
    if (!nome?.trim()) return;
    const novo = { id: proximoId.current++, nome: nome.trim(), dados: FICHA_VAZIA, vinculos: 0 };
    setModelos(prev => [...prev, novo]);
    setSelecionado(novo);
  }

  function renomearModelo(m) {
    const nome = window.prompt('Nome do modelo', m.nome);
    if (!nome?.trim() || nome.trim() === m.nome) return;
    setModelos(prev => prev.map(x => x.id === m.id ? { ...x, nome: nome.trim() } : x));
  }

  function excluirModelo(m) {
    if (m.vinculos > 0) {
      window.alert(`Não é possível excluir — ${m.vinculos} cliente${m.vinculos !== 1 ? 's' : ''} vinculado${m.vinculos !== 1 ? 's' : ''} a este modelo.`);
      return;
    }
    if (!window.confirm(`Excluir o modelo "${m.nome}"?`)) return;
    setModelos(prev => prev.filter(x => x.id !== m.id));
  }

  function atualizarDados(dados) {
    setModelos(prev => prev.map(m => m.id === selecionado.id ? { ...m, dados } : m));
    setSelecionado(prev => ({ ...prev, dados }));
  }

  if (selecionado) {
    return (
      <FichaCadastralTabs
        titulo={selecionado.nome}
        subtitulo="Modelo base — usado ao criar novos leads"
        dados={selecionado.dados}
        onChange={atualizarDados}
        onVoltar={() => setSelecionado(null)}
      />
    );
  }

  return (
    <div>
      <p className={styles.placeholderSub} style={{ marginBottom: 16 }}>
        Crie modelos base de Ficha Cadastral (regime, responsáveis, rotinas típicas...) para
        pré-preencher automaticamente o cadastro ao criar um novo lead.
      </p>

      <div className={styles.usuariosBarra}>
        <p className={styles.usuariosTotal}>
          {modelos.length} modelo{modelos.length !== 1 ? 's' : ''} cadastrado{modelos.length !== 1 ? 's' : ''}
        </p>
        <button type="button" className={styles.btnNovoUsuario} onClick={criarModelo}>
          <FiPlus size={14} /> Novo Modelo
        </button>
      </div>

      <div className={styles.modelosLista}>
        {modelos.map(m => (
          <div
            key={m.id}
            className={styles.modeloCard}
            onClick={() => setSelecionado(m)}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && setSelecionado(m)}
          >
            <div className={styles.modeloIcone}><FiClipboard size={16} /></div>
            <span className={styles.modeloNome}>{m.nome}</span>
            <div className={styles.usuarioAcoes}>
              <button
                type="button"
                className={styles.btnAcaoUsuario}
                title="Renomear"
                onClick={e => { e.stopPropagation(); renomearModelo(m); }}
              >
                <FiEdit2 size={13} />
              </button>
              <button
                type="button"
                className={`${styles.btnAcaoUsuario} ${styles.btnInativar}`}
                title={m.vinculos > 0 ? `${m.vinculos} cliente(s) vinculado(s) — não pode excluir` : 'Excluir'}
                onClick={e => { e.stopPropagation(); excluirModelo(m); }}
              >
                <FiTrash2 size={13} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===== Aba E-mail =====
   CRUD das contas IMAP/SMTP usadas pelo módulo E-mail (Painel/Gerenciamento).
   Senha nunca volta do backend em texto puro -- só um "senha_configurada"
   (ver backend/src/routes/email-contas.js). Editar sem preencher senha de
   novo mantém a senha já cifrada no banco. */

const CONTA_EMAIL_VAZIA = {
  nome: '', email: '', usuario: '', senha: '',
  imap_host: '', imap_porta: 993, imap_seguro: true,
  smtp_host: '', smtp_porta: 465, smtp_seguro: true,
  pasta_arquivo: 'Archive', pasta_enviados: 'Sent',
  setores: [],
};

function EmailTab() {
  const [contas, setContas]         = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [formAberto, setFormAberto] = useState(false);
  const [editando, setEditando]     = useState(null);
  const [form, setForm]             = useState(CONTA_EMAIL_VAZIA);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [salvando, setSalvando]     = useState(false);
  const [testando, setTestando]     = useState(false);
  const [testeResultado, setTesteResultado] = useState(null);
  const [erro, setErro]             = useState('');
  const [departamentos, setDepartamentos] = useState([]);

  function carregar() {
    setCarregando(true);
    listarContasEmail().then(r => setContas(r.items || [])).catch(e => setErro(e.message)).finally(() => setCarregando(false));
  }
  useEffect(() => { carregar(); }, []);
  useEffect(() => {
    listarDepartamentosNiboAPI().then(r => setDepartamentos(r.items || [])).catch(() => {});
  }, []);

  function abrirNovo() { setEditando(null); setForm(CONTA_EMAIL_VAZIA); setTesteResultado(null); setErro(''); setFormAberto(true); }
  function abrirEdicao(conta) {
    setEditando(conta);
    setForm({ ...CONTA_EMAIL_VAZIA, ...conta, senha: '', setores: conta.setores || [] });
    setTesteResultado(null); setErro(''); setFormAberto(true);
  }
  function fecharForm() { setFormAberto(false); setEditando(null); }
  function alternarSetor(nome) {
    setForm(p => ({ ...p, setores: p.setores.includes(nome) ? p.setores.filter(s => s !== nome) : [...p.setores, nome] }));
  }

  async function testarConexao() {
    setTestando(true); setTesteResultado(null); setErro('');
    try {
      await testarContaEmail({ ...form, id: editando?.id });
      setTesteResultado({ ok: true, msg: 'Conectou certinho.' });
    } catch (e) {
      setTesteResultado({ ok: false, msg: e.message });
    } finally {
      setTestando(false);
    }
  }

  async function handleSalvar() {
    if (!form.nome.trim() || !form.email.trim() || !form.imap_host.trim() || !form.smtp_host.trim() || !form.usuario.trim()) {
      setErro('Preencha nome, e-mail, usuário e os servidores IMAP/SMTP.'); return;
    }
    if (!editando && !form.senha) { setErro('Senha é obrigatória pra uma conta nova.'); return; }
    setSalvando(true); setErro('');
    try {
      if (editando) await atualizarContaEmail(editando.id, form);
      else await criarContaEmail(form);
      fecharForm();
      carregar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function excluir(conta) {
    if (!window.confirm(`Excluir a conta "${conta.nome}"? Os e-mails já sincronizados dela somem do Painel.`)) return;
    try {
      await excluirContaEmail(conta.id);
      carregar();
    } catch (e) {
      setErro(e.message);
    }
  }

  return (
    <div className={styles.usuariosWrap}>
      <div className={styles.usuariosBarra}>
        <p className={styles.usuariosTotal}>{contas.length} conta{contas.length !== 1 ? 's' : ''} de e-mail</p>
        <div className={styles.usuariosBarraAcoes}>
          <button type="button" className={styles.btnNovoUsuario} onClick={abrirNovo}>
            <FiPlus size={14} /> Nova conta
          </button>
        </div>
      </div>

      {erro && !formAberto && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>}

      {formAberto && (
        <div className={styles.usuarioForm}>
          <div className={styles.usuarioFormHeader}>
            <span className={styles.usuarioFormTitulo}>{editando ? 'Editar conta' : 'Nova conta de e-mail'}</span>
            <button type="button" className={styles.btnFecharForm} onClick={fecharForm}><FiX size={15} /></button>
          </div>

          <div className={styles.usuarioFormGrid}>
            <div className={styles.campo}>
              <label className={styles.label}>Nome de exibição</label>
              <input className={styles.input} value={form.nome} onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} placeholder="Ex.: Financeiro" />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>E-mail *</label>
              <input className={styles.input} type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="conta@empresa.com.br" />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>Usuário (login IMAP/SMTP) *</label>
              <input className={styles.input} value={form.usuario} onChange={e => setForm(p => ({ ...p, usuario: e.target.value }))} placeholder="geralmente igual ao e-mail" />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>Senha {editando ? '(deixe em branco pra manter a atual)' : '*'}</label>
              <div className={styles.chaveWrap}>
                <input
                  className={styles.input} type={mostrarSenha ? 'text' : 'password'}
                  value={form.senha} onChange={e => setForm(p => ({ ...p, senha: e.target.value }))}
                  placeholder="••••••••" autoComplete="new-password"
                />
                <button type="button" className={styles.btnOlho} onClick={() => setMostrarSenha(v => !v)}>
                  {mostrarSenha ? <FiEyeOff size={15} /> : <FiEye size={15} />}
                </button>
              </div>
            </div>

            <div className={styles.campo}>
              <label className={styles.label}>Servidor IMAP *</label>
              <input className={styles.input} value={form.imap_host} onChange={e => setForm(p => ({ ...p, imap_host: e.target.value }))} placeholder="imap.exemplo.com" />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>Porta IMAP</label>
              <input className={styles.input} type="number" value={form.imap_porta} onChange={e => setForm(p => ({ ...p, imap_porta: e.target.value }))} />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>Servidor SMTP *</label>
              <input className={styles.input} value={form.smtp_host} onChange={e => setForm(p => ({ ...p, smtp_host: e.target.value }))} placeholder="smtp.exemplo.com" />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>Porta SMTP</label>
              <input className={styles.input} type="number" value={form.smtp_porta} onChange={e => setForm(p => ({ ...p, smtp_porta: e.target.value }))} />
            </div>

            <div className={styles.campo}>
              <label className={styles.label}>Pasta de arquivados</label>
              <input className={styles.input} value={form.pasta_arquivo} onChange={e => setForm(p => ({ ...p, pasta_arquivo: e.target.value }))} placeholder="Archive" />
            </div>
            <div className={styles.campo}>
              <label className={styles.label}>Pasta de enviados</label>
              <input className={styles.input} value={form.pasta_enviados} onChange={e => setForm(p => ({ ...p, pasta_enviados: e.target.value }))} placeholder="Sent" />
            </div>
          </div>

          <div style={{ margin: '10px 0' }}>
            <label className={styles.label}>Setores com acesso (deixe em branco pra liberar pra todo mundo)</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
              {departamentos.map(d => (
                <label
                  key={d.id}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 5, fontSize: 12.5, cursor: 'pointer',
                    border: '1px solid #e2e8f0', borderRadius: 999, padding: '4px 10px',
                    background: form.setores.includes(d.name) ? '#16202e' : '#fff',
                    color: form.setores.includes(d.name) ? '#fff' : '#16202e',
                  }}
                >
                  <input type="checkbox" checked={form.setores.includes(d.name)} onChange={() => alternarSetor(d.name)} style={{ display: 'none' }} />
                  {d.name}
                </label>
              ))}
              {!departamentos.length && <span className={styles.placeholderSub}>Nenhum setor cadastrado (ver departamentos da Nibo).</span>}
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '10px 0' }}>
            <button type="button" className={styles.btnCancelarForm} onClick={testarConexao} disabled={testando || !form.imap_host || !form.usuario}>
              <FiZap size={13} /> {testando ? 'Testando...' : 'Testar conexão IMAP'}
            </button>
            {testeResultado && (
              <span style={{ fontSize: 12.5, color: testeResultado.ok ? '#0f7a48' : '#d0453b', fontWeight: 600 }}>
                {testeResultado.ok ? <FiCheckCircle size={13} /> : <FiAlertCircle size={13} />} {testeResultado.msg}
              </span>
            )}
          </div>

          {erro && <div className={styles.erroFaixa}><FiAlertCircle size={14} /> {erro}</div>}

          <div className={styles.usuarioFormFooter}>
            <button type="button" className={styles.btnCancelarForm} onClick={fecharForm}>Cancelar</button>
            <button type="button" className={styles.btnSalvar} onClick={handleSalvar} disabled={salvando}>
              <FiSave size={14} /> {salvando ? 'Salvando...' : editando ? 'Salvar Alterações' : 'Criar Conta'}
            </button>
          </div>
        </div>
      )}

      {carregando ? (
        <p className={styles.placeholderSub}>Carregando contas...</p>
      ) : (
        <div className={styles.usuariosLista}>
          {contas.map(c => (
            <div key={c.id} className={`${styles.usuarioCard} ${!c.ativo ? styles.usuarioCardInativo : ''}`}>
              <div className={styles.usuarioAvatar}>{(c.nome || c.email || '?').charAt(0).toUpperCase()}</div>
              <div className={styles.usuarioInfo}>
                <div className={styles.usuarioNomeRow}>
                  <span className={styles.usuarioNome}>{c.nome}</span>
                  {!c.ativo && <span className={styles.inativoBadge}>Inativa</span>}
                  {!c.senha_configurada && <span className={styles.inativoBadge}>Sem senha</span>}
                </div>
                <span className={styles.usuarioEmail}>
                  {c.email} — {c.imap_host}{c.setores?.length ? ` — ${c.setores.join(', ')}` : ' — todos os setores'}
                </span>
              </div>
              <div className={styles.usuarioAcoes}>
                <button type="button" className={styles.btnAcaoUsuario} onClick={() => abrirEdicao(c)} title="Editar">
                  <FiEdit2 size={14} />
                </button>
                <button
                  type="button"
                  className={`${styles.btnAcaoUsuario} ${c.ativo ? styles.btnInativar : styles.btnReativar}`}
                  onClick={() => atualizarContaEmail(c.id, { ativo: !c.ativo }).then(carregar).catch(e => setErro(e.message))}
                  title={c.ativo ? 'Inativar' : 'Reativar'}
                >
                  {c.ativo ? <FiUserX size={14} /> : <FiUserCheck size={14} />}
                </button>
                <button type="button" className={`${styles.btnAcaoUsuario} ${styles.btnInativar}`} onClick={() => excluir(c)} title="Excluir">
                  <FiTrash2 size={14} />
                </button>
              </div>
            </div>
          ))}
          {!contas.length && <p className={styles.placeholderSub}>Nenhuma conta cadastrada ainda.</p>}
        </div>
      )}
    </div>
  );
}

/* ===== Página principal ===== */

function Configuracoes() {
  const [abaAtiva, setAbaAtiva] = useState('sistema');

  return (
    <div className={styles.page}>

      <div className={styles.header}>
        <div className={styles.headerIcone}>
          <FiSettings size={18} />
        </div>
        <div>
          <h1 className={styles.titulo}>Configurações</h1>
          <p className={styles.subtitulo}>Gerencie sistema, usuários e permissões</p>
        </div>
      </div>

      <div className={styles.tabBar}>
        {ABAS.map(aba => {
          const Icone = aba.icon;
          return (
            <button
              key={aba.id}
              type="button"
              className={`${styles.tab} ${abaAtiva === aba.id ? styles.tabAtiva : ''}`}
              onClick={() => setAbaAtiva(aba.id)}
            >
              <Icone size={15} />
              {aba.label}
            </button>
          );
        })}
      </div>

      <div className={styles.conteudo}>
        {abaAtiva === 'sistema'       && <SistemaTab />}
        {abaAtiva === 'usuarios'      && <UsuariosTab />}
        {abaAtiva === 'perfil-acesso' && <PerfilAcessoTab />}
        {abaAtiva === 'contratos'     && <Placeholder titulo="Contratos" />}
        {abaAtiva === 'modelos-ficha' && <ModelosFichaTab />}
        {abaAtiva === 'nibo-responsaveis' && <NiboResponsaveisTab />}
        {abaAtiva === 'email'         && <EmailTab />}
        {abaAtiva === 'docs'          && <DocsTab />}
        {abaAtiva === 'auditoria'     && <Auditoria />}
      </div>

    </div>
  );
}

export default Configuracoes;
